function dm_c_14_content_with_profile(){
    const modules = document.querySelectorAll('.c-14-content-with-profile');

    if (!modules.length) {
        return;
    }

    const bindInteraction = (element, handler) => {
        let touchHandled = false;

        element.addEventListener('touchend', (event) => {
            touchHandled = true;
            event.preventDefault();
            handler(event);
        }, { passive: false });

        element.addEventListener('click', (event) => {
            if (touchHandled) {
                touchHandled = false;
                return;
            }
            handler(event);
        });
    };

    modules.forEach((module) => {
        const toggle = module.querySelector('.expert-toggle');
        const panel = module.querySelector('.profile-cont');
        const closeBtn = module.querySelector('.profile-cont .btn-close');
        const img = module.querySelector('.profile-cont img');

        // Preload image on iOS to ensure it's available when panel opens
        if (img && img.src) {
            const imageLoader = new Image();
            imageLoader.src = img.src;
        }

        if (toggle && panel) {
            bindInteraction(toggle, () => {
                panel.classList.add('active');
                document.body.classList.add('no-scroll'); // optional to prevent background scroll
            });
        }

        if (closeBtn && panel) {
            bindInteraction(closeBtn, () => {
                panel.classList.remove('active');
                document.body.classList.remove('no-scroll');
            });
        }
    });
}

export { dm_c_14_content_with_profile };